import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/navbar/questions_icon_on.svg'
import _imports_1 from '@/assets/img/bomb.svg'


const _withScopeId = n => (_pushScopeId("data-v-4717805c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mx-0" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon pe-1",
  src: _imports_0
}, null, -1))
const _hoisted_5 = { class: "row mx-0 mt-3" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "header_name fw_600 mb-0" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "header_name fw_600 mb-0" }
const _hoisted_11 = { class: "row mx-0 mt-3" }
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { class: "header_name fw_600 mb-0" }
const _hoisted_14 = { class: "col-4" }
const _hoisted_15 = { class: "header_name fw_600 mb-0" }
const _hoisted_16 = {
  key: 0,
  class: "col-4"
}
const _hoisted_17 = { class: "header_name fw_600 mb-0" }
const _hoisted_18 = { class: "d-flex mt-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradientOverlay" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_21 = { class: "fev_text1 fw_800 question" }
const _hoisted_22 = { class: "w-100" }
const _hoisted_23 = { class: "answers_div" }
const _hoisted_24 = { class: "flex_centered mt-3" }
const _hoisted_25 = {
  key: 0,
  class: "bomb",
  src: _imports_1
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_localized_text, {
          class: "fev_text6 mb-1",
          localizedKey: "backoffice_StatoDellaRisposta",
          text: "Stato Della Risposta"
        }),
        _createVNode(_component_localized_text, {
          type: "h4",
          class: "fw_600",
          localizedKey: 'backoffice_replystatus_' + _ctx.replyStatus[_ctx.affinityReply.status],
          text: _ctx.replyStatus[_ctx.affinityReply.status]
        }, null, 8, ["localizedKey", "text"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.affinityReply.statusHistory && _ctx.affinityReply.statusHistory.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "pe-3 d-flex align-items-center pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHistory && _ctx.openHistory(...args)))
            }, [
              _hoisted_4,
              _createVNode(_component_localized_text, {
                class: "fev_text3 text_underlined",
                localizedKey: "backoffice_VediStoricoStato",
                text: "Vedi Storico Dello Stato"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_localized_text, {
          class: "fev_text6 mb-1",
          localizedKey: "backoffice_HaRipostoA",
          text: "Ha Risposto A"
        }),
        _createElementVNode("h4", {
          class: "header_name fw_600 mb-0 pointer text_underlined",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToUser(_ctx.affinityReply.appUser.identifier)))
        }, _toDisplayString(_ctx.affinityReply.appUser.text), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_localized_text, {
          class: "fev_text6 mb-1",
          localizedKey: "backoffice_HaRaggiuntoLAffinityRate",
          text: "Ha Raggiunto L'Affinity Rate"
        }),
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.affinityReply.isOverMinimumAffinity), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_localized_text, {
          class: "fev_text6 mb-1",
          localizedKey: "backoffice_HaPresoLaBomba",
          text: "Ha Preso La Bomba"
        }),
        _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.affinityReply.bombTriggered), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_localized_text, {
          class: "fev_text6 mb-1",
          localizedKey: "backoffice_AffinityRateMinimo",
          text: "Affinity Rate Minimo"
        }),
        _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.affinityReply.minimumAffinityPercentage) + "%", 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_localized_text, {
          class: "fev_text6 mb-1",
          localizedKey: "backoffice_AffinityRateRaggiunto",
          text: "Affintiy Rate Raggiunto"
        }),
        _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.affinityReply.affinityPercentage) + "%", 1)
      ]),
      (_ctx.affinityReply.secondChanceSeenOn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_localized_text, {
              class: "fev_text6 mb-1",
              localizedKey: "backoffice_SecondChanceVistaIl",
              text: "Second Chance Vista Il"
            }),
            _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.$filters.date(_ctx.affinityReply.secondChanceSeenOn, "DD/MM/yyyy HH:mm")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affinityReply.answers, (answer, index) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_18, [
        _createElementVNode("div", {
          class: "imageCardContainer flex-shrink-0 bg_blue mb-4",
          style: _normalizeStyle('background-image: url(\'' + answer.imageUrl + '\')')
        }, [
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("span", _hoisted_21, _toDisplayString(answer.question), 1)
        ], 4),
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer.answers, (answerInAnswer, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("button", {
                class: _normalizeClass(["fev_button mb-3", answer.answerIndex != -1 && answer.answerIndex == index ? 'blue' : 'box_shadow'])
              }, [
                _createElementVNode("span", null, _toDisplayString(answerInAnswer.answer), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(answerInAnswer.percentage) + " %", 1),
                  (answerInAnswer && answerInAnswer > answerInAnswer.percentage)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]))
          }), 256))
        ])
      ]))
    }), 256))
  ], 64))
}